export default __webpack_public_path__ + "static/media/logsActionIcon.44a3e114.svg";